import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { layout, radius } from '../../themes/smartinventoryTheme';

// Card-list equivalent of SkeletonTable — used by page types that render
// cards instead of a grid (categories, coupons, ads, mobile row-to-card).
const SkeletonCards = ({ rows = 6 }) => (
  <Box>
    {Array.from({ length: rows }).map((_, index) => (
      <Box
        key={index}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: `${radius.xl}px`,
          p: 1.5,
          mb: 1,
        }}
      >
        <Skeleton variant="rounded" width={layout.rowThumbSize} height={layout.rowThumbSize} sx={{ flexShrink: 0 }} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="rounded" height={12} width="55%" sx={{ mb: 0.75 }} />
          <Skeleton variant="rounded" height={10} width="80%" />
        </Box>
      </Box>
    ))}
  </Box>
);

export default SkeletonCards;
